"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    "in": 'in',
    option: 'Option',
    addOption: 'Add option',
    defaultLanguage: 'Default',
    languageError: 'Default language can\'t be blank',
    languages: {
      en: 'English',
      es: 'Spanish',
      fr: 'French',
      it: 'Italian',
      de: 'German',
      ru: 'Russian'
    }
  },
  es: {
    "in": 'en',
    option: 'Opción',
    addOption: 'Agregar opción',
    defaultLanguage: 'Principal',
    languageError: 'El idioma por defecto no puede estar vacio',
    languages: {
      en: 'Inglés',
      es: 'Español',
      fr: 'Francés',
      it: 'Italiano',
      de: 'Alemán',
      ru: 'Ruso'
    }
  },
  fr: {
    "in": 'en',
    option: 'Option',
    addOption: 'Ajouter une option',
    defaultLanguage: 'Directeur',
    languageError: 'La langue par défaut ne peut pas être vide',
    languages: {
      en: 'Anglais',
      es: 'Espagnol',
      fr: 'Français',
      it: 'Italien',
      de: 'Allemand',
      ru: 'Russe'
    }
  },
  de: {
    "in": 'auf',
    option: 'Option',
    addOption: 'Möglichkeit hinzufügen',
    defaultLanguage: 'Rektorin',
    languageError: 'Standardsprache darf nicht leer sein',
    languages: {
      en: 'Englisch',
      es: 'Spanisch',
      fr: 'Französisch',
      it: 'Italienisch',
      de: 'Detusch',
      ru: 'Russisch'
    }
  }
};
exports["default"] = _default;